<template lang="html">
  <walkthrough-stepper
    @close="$emit('close')"
    :pageTitles="page_titles"
    stepperTitle="RoundTable Configuration"
  >
    <template slot-scope="{ page }">
      <div class="mh3 pa3 flex-grow" v-show="page === 0">
        <div class="flex justify-center">
          <i class="fas fa-eye-slash fa-3x ma3" />
        </div>
        <div class="pl-subheading">
          Turn on <span class="italics">Anonymity Mode</span>
          to allow students to explore ideas in the discussion with secret
          identities.
          <br /><br />
          Use the <i class="fas fa-eye mh1" /> button on the left hand side to
          toggle their real and secret identities.
        </div>
      </div>
      <div class="mh3 pa3 flex-grow" v-show="page === 1">
        <div class="flex justify-center">
          <i class="fas fa-clipboard-list fa-3x ma3" />
        </div>
        <div class="pl-subheading">
          Create rubrics (criteria, definition and scale) to evaluate individual
          student engagement and provide personalized feedback.
          <br /><br />
          You are able to assess your students by clicking the
          <span class="italics">Assessment Tab</span> in their submission.
        </div>
      </div>
      <div class="mh3 pa3 flex-grow" v-show="page === 2">
        <div class="flex justify-center">
          <i class="fas fa-map-signs fa-3x ma3" />
        </div>
        <div class="pl-subheading">
          Use guidance questions to help students practice giving structured and
          meaningful feedback.
        </div>
      </div>
    </template>
  </walkthrough-stepper>
</template>
<script>
  import WalkthroughStepper from 'features/onlineWalkthrough/onlineWalkthroughStepper';

  export default {
    data() {
      return {
        page_titles: ['Anonymity', 'Assessment', 'Guidance'],
      };
    },
    components: {
      WalkthroughStepper,
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// onlineWalkthroughConfiguration.vue?038107ef